import { render, staticRenderFns } from "./WaitPayPopup.vue?vue&type=template&id=8c7cfa44&scoped=true"
import script from "./WaitPayPopup.vue?vue&type=script&lang=js"
export * from "./WaitPayPopup.vue?vue&type=script&lang=js"
import style0 from "./WaitPayPopup.vue?vue&type=style&index=0&id=8c7cfa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7cfa44",
  null
  
)

export default component.exports